// extracted by mini-css-extract-plugin
export default {"serviceChip":"ServiceChip_serviceChip__USye5"};